<template>
    <access-denied v-if="accessDenied" title="agenda" />
    <div id="main" v-else>
        <container-loader v-if="isLoading && !$store.getters.isLoading" />
        <div class="page">
            <div class="vertical-flow">
                <div class="listing-header">
                    <!-- TÍTULO E BREADCRUMB -->
                    <div class="title-breadcrumb">
                        <h1 class="title">{{ $t('agenda') }}</h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs" v-if="cameFrom == 'route'">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{ $t('vendas') }}</a>
                                </li>
                                <li>
                                    <a class="a-inativo">{{ $t('crm') }}</a>
                                </li>
                                <li>
                                    <a aria-current="page">{{ $t('agenda') }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            v-if="cameFrom != 'route'"
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="$emit('voltar', true)"
                        >
                            {{ $t('voltar') }}
                        </button>
                        <button
                            v-if="!integracao && permissao.create && cameFrom == 'route'"
                            class="save-btn"
                            type="button"
                            tag="button"
                            @click="showModalAgendaManage = true"
                        >
                            <!-- @click="
                                $router.push({
                                    name: 'crm-agenda-new',
                                })
                            " -->
                            {{ $t('adicionar') }}
                        </button>
                    </div>
                </div>

                <!-- PESQUISA E FILTROS -->
                <div class="filters-bar mb-3">
                    <div class="filters-bar-form form-columns-fit">
                        <div class="columns">
                            <div class="column is-4">
                                <search-bar
                                    :clean="limparBusca"
                                    :onSearch="debouncedOnSearch"
                                    ref="search"
                                    :tooltipLabel="$t('msg-campo-busca-n', 
                                        { n: $t('titulo') + ', ' + $t('observacao') })
                                    "
                                />
                            </div>
                            <!-- Data Inicio-->
                            <div class="column is-4">
                                <verified-date-picker
                                    dateType="startDate"
                                    :value="datainicial"
                                    :endDate="datafinal"
                                    title="data-inicio"
                                    @input="changeStartDate"
                                    :showClean="false"
                                    required
                                    :invalid="datainicial == null"
                                />
                            </div>
                            <!-- Data Fim-->
                            <div class="column is-4">
                                <verified-date-picker
                                    dateType="endDate"
                                    :value="datafinal"
                                    :startDate="datainicial"
                                    title="data-fim"
                                    :addDateYears="2"
                                    @input="changeEndDate"
                                    :showClean="false"
                                    required
                                    :invalid="datafinal == null"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="filters-bar-actions">
                        <b-button
                            type="is-primary"
                            icon-right="filter"
                            @click="showFilter = !showFilter"
                            class="mr-2"
                            v-tippy 
                            :title="$t('filtros')"
                        />
                        <b-button
                            type="is-primary"
                            :icon-right="showCalendar ? 'table' : 'calendar'"
                            @click="
                                showCalendar = !showCalendar;
                                resetPagination();
                            "
                            v-tippy 
                            :title="$t(showCalendar ? 'tabela' : 'calendario')"
                        />
                    </div>
                </div>
                <!-- LISTAGEM -->
                <div class="registry-wrapper">
                    <AgendaListCalendar
                        v-if="showCalendar"
                        :minDate="datainicial"
                        :maxDate="datafinal"
                        :events="events"
                        :isEmpty="isEmpty"
                        :isLoading="isLoading"
                        @uuidAgendaManage="uuidAgendaManage = $event"
                        @showModalAgendaManage="showModalAgendaManage = $event"
                        @new="
                            newEvent = $event;
                            showModalAgendaManage = true;
                        "
                    />
                    <AgendaListTable
                        v-else
                        :evento="evento"
                        :modalForDelete="modalForDelete"
                        :callShowModal="callShowModal"
                        :isMobile="isMobile"
                        :sortTable="sortTable"
                        :isEmpty="isEmpty"
                        :isLoading="isLoading"
                        :cameFrom="cameFrom"
                        @uuidAgendaManage="uuidAgendaManage = $event"
                        @showModalAgendaManage="showModalAgendaManage = $event"
                        @edit="$emit('edit', $event)"
                    />
                </div>
                <PaginationViewer
                    v-if="!showCalendar && !isEmpty"
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>
        </div>
        <!-- Filtro lateral -->
        <lateral-content :isLoading="isLoading" v-model="showFilter" compact footer>
            <div class="bg p-3">
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-12">
                            <vss-select
                                :options="situacaoSelect"
                                v-model="situacaoSelected"
                                mlLabels
                                title="situacao"
                                clearable
                                @input="onCleanSituacao"
                            />
                        </div>
                        <div class="column is-12">
                            <vss-select
                                title="tipo-agenda"
                                :options="tipoAgendaSelect"
                                v-model="tipoAgendaSelected"
                                :loading="tipoAgendaLoading"
                                @search="carregarTipoAgenda"
                                multiple
                                searchable
                                clearable
                                :closeOnSelect="false"
                                iconPosition="left"
                            />
                        </div>
                        <div class="column is-12">
                            <vss-select
                                title="colaborador"
                                v-model="usuarioSelected"
                                :options="usuarioSelect"
                                :loading="usuarioLoading"
                                @search="carregarUsuario"
                                label="nome"
                                multiple
                                searchable
                                clearable
                                :closeOnSelect="false"
                            />
                        </div>
                        <div class="column is-12">
                            <vss-select
                                title="cliente"
                                :options="clienteSelect"
                                v-model="clienteSelected"
                                :loading="clienteLoading"
                                @search="carregarCliente"
                                @input="loadPropriedade(null, true)"
                                multiple
                                searchable
                                clearable
                                :closeOnSelect="false"
                            />
                        </div>
                        <div class="column is-12">
                            <vss-select
                                title="propriedade"
                                v-model="propriedadeSelected"
                                :options="propriedadeSelect"
                                :loading="propriedadeLoading"
                                @search="loadPropriedade"
                                label="nome"
                                multiple
                                searchable
                                clearable
                                :closeOnSelect="false"
                                :disabled="clienteSelected.length == 0"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <template v-slot:footer-right="{ id }">
                <b-button
                    type="is-warning is-silver"
                    icon-right="backspace"
                    @click="onCleanFilters()"
                    class="mr-2"
                    :disabled="isLoading"
                >
                    {{ $t('limpar') }}
                </b-button>
                <b-button
                    type="is-primary"
                    icon-right="filter"
                    @click="timeoutCarregarDados()"
                    :disabled="isLoading"
                >
                    {{ $t('filtrar') }}
                </b-button>
            </template>
        </lateral-content>
        <!-- compact -->
        <lateral-content v-model="showModal"  header :title="eventoSelectedTitulo">
            <div class="bg p-3" v-if="showModal">
                <AgendaUsuarioList
                    :evento="
                        evento != null
                            ? evento.filter((f) => f.uuid == eventoSelectedUuid)[0]
                            : null
                    "
                    :reloadData="isLoading"
                    @saved="carregarDados(pagination.currentPage)"
                />
            </div>
        </lateral-content>
        <lateral-content v-model="showModalAgendaManage" confirmClose>
            <AgendaManage
                compact
                class="pt-4"
                v-if="showModalAgendaManage"
                cameFrom="DespesaManage"
                :idFrom="uuidAgendaManage"
                @saved="
                    carregarDados(pagination.currentPage);
                    showModalAgendaManage = false;
                    newEvent = null;
                "
                @updated="carregarDados(pagination.currentPage)"
                @voltar="showModalAgendaManage = false"
                :newEvent="newEvent"
            />
        </lateral-content>
        <lateral-content
            v-model="showModalDelete"
            compact
            header
            :title="selected != null ? selected.crmAgenda.titulo : ''"
        >
            <div class="bg p-3" v-if="showModalDelete">
                <div class="columns is-flex-wrap">
                    <div class="column is-12">
                        <div class="box clickable" @click="promptForDelete(false)">
                            {{ $t('excluir-somente-este-evento') }}
                        </div>
                    </div>
                    <div class="column is-12">
                        <div class="box clickable" @click="promptForDelete(true)">
                            {{ $t('excluir-este-e-os-subsequentes') }}
                        </div>
                    </div>
                    <div class="column is-12 light-gray-color">
                        <i>* {{ $t('eventos-com-execucao-nao-serao-excluidos') }} </i>
                    </div>
                </div>
            </div>
        </lateral-content>
    </div>
</template>

<script>
import CrmAgendaService from '@/services/vendas/crm/CrmAgendaService.js';
import ClienteService from '@/services/vendas/cliente/ClienteService.js';
import GerenciarUsuariosService from '@/services/conta/GerenciarUsuariosService.js';
import TipoAgendaAtividadeService from '@/services/TipoAgendaAtividadeService.js';
import PropriedadeService from '@/services/agro/PropriedadeService.js';
import ContainerLoader from '@/components/content/loader/ContainerLoader.vue';
import FiltroLateral from '@/components/shared/FiltroLateral.vue';
import AgendaUsuarioList from '@/components/vendas/agenda/AgendaUsuarioList.vue';
import AgendaListTable from '@/components/vendas/agenda/AgendaListTable.vue';
import AgendaListCalendar from '@/components/vendas/agenda/AgendaListCalendar.vue';
const AgendaManage = () => import('@/components/vendas/agenda/AgendaManage.vue');

export default {
    name: 'AgendaList',

    components: {
        ContainerLoader,
        FiltroLateral,
        AgendaUsuarioList,
        AgendaManage,
        AgendaListTable,
        AgendaListCalendar,
    },

    props: {
        cameFrom: {
            type: String,
            default: 'route',
        },
        idFrom: {
            type: Number,
            default: 0,
        },
        reloadData: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            integracao: this.$store.state.user.tabelasERPWebServer.includes('CRM_AGENDA'),
            evento: [],
            events: [], // para o calendário
            service: new CrmAgendaService(this.$http, this.$router),
            clienteService: new ClienteService(this.$http, this.$router),
            gerenciarUsuariosService: new GerenciarUsuariosService(this.$http, this.$router),
            tipoAgendaService: new TipoAgendaAtividadeService(this.$http, this.$router),
            propriedadeService: new PropriedadeService(this.$http, this.$router),

            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            permissao: {},
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },

            showFilter: false,
            limparBusca: false,
            situacaoSelect: [
                { label: 'todos', id: 2 },
                { label: 'finalizado', id: 1 },
                { label: 'aberto', id: 0 },
            ],
            situacaoSelected: { label: 'todos', id: 2 },
            tipoAgendaSelect: [],
            tipoAgendaSelected: [],
            tipoAgendaLoading: false,
            clienteSelect: [],
            clienteSelected: [],
            clienteLoading: false,
            propriedadeSelect: [], // uui
            propriedadeSelected: null,
            propriedadeLoading: false,
            usuarioSelect: [],
            usuarioSelected: [],
            usuarioLoading: false,
            // filtros
            filters: {
                queryFilter: '.*',
                column: 'DATA_HORA_INICIO',
                order: 'desc',
                situacao: 2,
                currentPage: 1,
                perPage: 10,
                datainicial: null,
                datafinal: null,
                clienteList: [],
                propriedadeList: [],
                usuarioList: [],
                tipoAgendaList: [],
            },
            datainicial: this.minusWeeks(new Date(), 4),
            datafinal: this.addWeeks(new Date(), 4),
            eventoSelectedUuid: null,
            eventoSelectedTitulo: null,
            showModal: false,
            accessDenied: false,
            showModalAgendaManage: false,
            uuidAgendaManage: null,
            showModalDelete: false,
            selected: null,
            showCalendar: false,
            newEvent: null,
        };
    },
    created() {
        this.$cookies.set('crm-agenda', 'list');

        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.permissao = this.hasPermissionAccess('vendas', 'crm', 'crm-agenda');

        if (!this.permissao.read) {
            this.accessDenied = true;
        } else {
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.carregarDados();
        }
    },
    watch: {
        reloadData(val) {
            if (val) this.carregarDados(this.pagination.currentPage);
        },
        showModalAgendaManage(val) {
            if (!val) this.uuidAgendaManage = null;
        },
    },
    methods: {
        isMobile() {
            return window.innerWidth <= 760;
        },
        // Recebe o $emit do VerifiedDatePicker, adiciona o valor na variavel local que retorna para a prop do VerifiedDatePiker
        changeStartDate(date) {
            if (date.getTime() != this.datainicial.getTime()) {
                this.datainicial = date;
                if (!this.isNull(this.datainicial)) this.carregarDados();
            }
        },
        changeEndDate(date) {
            if (date.getTime() != this.datafinal.getTime()) {
                this.datafinal = date;
                if (!this.isNull(this.datafinal)) this.carregarDados();
            }
        },
        minusWeeks(date, weeks) {
            date.setDate(date.getDate() - 7 * weeks);
            return date;
        },
        addWeeks(date, weeks) {
            date.setDate(date.getDate() + 7 * weeks);
            return date;
        },
        sortTable(field, order) {
            this.filters.column = field;
            this.filters.order = order;
            this.carregarDados();
        },
        resetPagination() {
            if (this.showCalendar) {
                this.pagination.perPage = 10000;
            } else {
                this.pagination.perPage = this.pagination.perPageOptions[
                    this.pagination.optionStarted
                ];
            }
            this.pagination.resetPagination = true;
            this.pagination.currentPage = 1;
            this.carregarDados(1);
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        onSearch(value) {
            this.filters.queryFilter = this.removeToSearch(value, true);
            this.carregarDados(1);
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;

            this.fillFilter(currentPage);

            this.service
                .findAll(this.filters)
                .then(this.mapItems)
                .then((value) => {
                    this.evento = value;
                    this.isEmpty = this.evento.length <= 0;
                })
                .catch((e) => {
                    this.evento = [];
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                })
                .finally((_) => {
                    this.pagination.resetPagination = false;
                    this.isLoading = false;
                    if (this.evento.length > 0) {
                        this.events = this.evento.map((m) => {
                            return {
                                class:
                                    m.colaborador_aberto_qtd == 0 ? 'bar-finalizada' : 'bar-aberta',
                                start: new Date(m.data_hora_inicio),
                                end: new Date(m.data_hora_fim),
                                title: m.crmAgenda.titulo,
                                evento: m,
                            };
                        });
                    }
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            return body.content.map((m) => {
                let crmAssAgendaEventoUsuarioList = this.mapColaboradorList(
                    m.crmAssAgendaEventoUsuarioList,
                    m.data_hora_fim,
                    m.crmAgenda.idusuario_insercao
                );
                let atraso = crmAssAgendaEventoUsuarioList.reduce(
                    (n, f) => (f.atrasado ? n + 1 : n),
                    0
                );
                let haveMe = crmAssAgendaEventoUsuarioList.reduce(
                    (n, f) => (f.idusuario == this.$store.state.user.usuario.id ? n + 1 : n),
                    0
                );
                let iCanChange = crmAssAgendaEventoUsuarioList.reduce(
                    (n, f) => (f.iCanChange ? n + 1 : n),
                    0
                );

                return {
                    id: m.id,
                    codigo: m.idcrm_agenda_eventoerp,
                    uuid: m.uuid,
                    crmAgenda: m.crmAgenda,
                    crmAssAgendaEventoUsuarioList: crmAssAgendaEventoUsuarioList,
                    colaboradorHaveMe: haveMe > 0,
                    iCanChange:
                        iCanChange > 0 ||
                        (crmAssAgendaEventoUsuarioList == 0 && this.$store.state.user.admin),
                    colaborador_executado_qtd: m.crmAssAgendaEventoUsuarioList.reduce(
                        (n, f) => (f.crmAgendaExecucao != undefined ? n + 1 : n),
                        0
                    ),
                    colaborador_aberto_qtd: m.crmAssAgendaEventoUsuarioList.reduce(
                        (n, f) => (f.crmAgendaExecucao == undefined ? n + 1 : n),
                        0
                    ),
                    atraso: atraso > 0,
                    situacao: m.situacao,
                    data_hora_inicio: m.data_hora_inicio,
                    data_hora_fim: m.data_hora_fim,
                    excluir: 'excluir',
                };
            });
        },
        mapColaboradorList(colaboradorList, data_hora_fim, idusuario_insercao) {
            data_hora_fim = new Date(data_hora_fim);
            let agora = new Date();
            return colaboradorList.map((m) => {
                let isSubordinado = this.$store.state.user.usuario.assusuariousuarioList.reduce(
                    (n, f) => (f.idusuario = m.idusuario ? n + 1 : n),
                    0
                );
                let iCanChange =
                    (isSubordinado > 0 && idusuario_insercao == this.$store.state.user.usuario.id) ||
                    this.$store.state.user.admin;
                return {
                    id: m.id,
                    idusuario: m.idusuario,
                    codigo: m.idcrm_ass_agenda_evento_usuarioerp,
                    uuid: m.uuid,
                    nome: m.usuario.nome,
                    usuario: m.usuario,
                    executado: m.crmAgendaExecucao != undefined,
                    crmAgendaExecucao: m.crmAgendaExecucao,
                    atrasado:
                        m.crmAgendaExecucao != undefined
                            ? data_hora_fim < new Date(m.crmAgendaExecucao.data_hora_inicio)
                            : data_hora_fim < agora,
                    situacao: m.situacao,
                    iCanChange: iCanChange,
                };
            });
        },
        fillFilter(currentPage = 1) {
            this.filters.situacao = this.situacaoSelected != null ? this.situacaoSelected.id : null;
            this.filters.tipoAgendaList = this.tipoAgendaSelected
                ? this.tipoAgendaSelected.map((e) => e.id)
                : [];
            this.filters.clienteList = this.clienteSelected
                ? this.clienteSelected.map((e) => e.id)
                : [];
            this.filters.propriedadeList = this.propriedadeSelected
                ? this.propriedadeSelected.map((e) => e.uuid)
                : [];
            this.filters.usuarioList = this.usuarioSelected
                ? this.usuarioSelected.map((e) => e.id)
                : [];

            this.filters.perPage = this.pagination.perPage;
            this.filters.currentPage = currentPage;
            this.filters.queryFilter = this.filters.queryFilter || '.*';

            this.filters.datainicial = this.datainicial
                ? this.$moment(this.datainicial).format('YYYY-MM-DD')
                : null;
            this.filters.datafinal = this.datafinal
                ? this.$moment(this.datafinal).format('YYYY-MM-DD')
                : null;

            if (this.filters.column == 'codigo') {
                this.filters.column = 'iddes_acerto_despesaerperp';
            }
        },
        onCleanSituacao(val) {
            if (!val) this.situacaoSelected = this.situacaoSelect[0];
        },
        onCleanFilters() {
            this.situacaoSelected = this.situacaoSelect[0];
            this.tipoAgendaSelected = [];
            this.clienteSelected = [];
            this.propriedadeSelect = [];
            this.propriedadeSelected = null;
            this.usuarioSelected = [];
            this.filters.queryFilter = '';
            this.datainicial = this.minusWeeks(new Date(), 4);
            this.datafinal = this.addWeeks(new Date(), 4);
            this.$refs.search.cleanSearch();

            this.timeoutCarregarDados();
        },
        timeoutCarregarDados(time = 600) {
            this.showFilter = false;
            setTimeout(() => {
                this.carregarDados();
                this.limparBusca = false;
            }, time);
        },
        modalForDelete(row) {
            this.selected = row;
            if (this.selected.crmAgenda.qtd_recorrencia_apartirde > 0) {
                this.showModalDelete = true;
            } else {
                this.promptForDelete(false);
            }
        },
        promptForDelete(recorrencia = false) {
            this.$root.confirm({
                message: this.$t('msg-confirmacao-exclusao-n', 
                    { n: this.selected.crmAgenda.titulo }
                ),
                onConfirm: (_) => this.updateSituacao(recorrencia),
            });
        },
        callShowModal(uuid, titulo) {
            this.eventoSelectedUuid = uuid;
            this.eventoSelectedTitulo = titulo;
            this.showModal = true;
        },

        updateSituacao(recorrencia = false) {
            this.isLoading = true;

            let temp = {
                uuidcrm_agenda: this.selected.crmAgenda.uuid,
                uuid: this.selected.uuid,
                data_hora_inicio: this.selected.data_hora_inicio,
            };

            this.service
                .updateSituacao(temp, recorrencia)
                .then((value) => {
                    if (value.message == null) {
                        let msg = this.$t('msg-delete-sucesso-n', { n: this.$t('agenda') });
                        this.$root.showMessage('success', msg, true, false);
                        this.carregarDados(this.pagination.currentPage);
                    } else {
                        if (this.$t(value.message)) {
                            this.$root.showMessage('alert', value.message, true);
                        } else {
                            this.$root.showMessage('error', 'msg-problema-realizar-acao', true);
                        }
                    }
                })
                .catch((e) => {
                    if (e.body && !this.isNull(e.body.message) && this.$te(e.body.message)) {
                        this.$root.showMessage('alert', this.$t(e.body.message), true, false);
                    } else {
                        this.$root.showMessage('error', 'msg-problema-realizar-acao', true);
                    }
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.showModalDelete = false;
                    this.selected = null;
                });
        },
        carregarTipoAgenda(query) {
            query = this.isNull(query) ? '.*' : this.removeToSearch(query);

            this.tipoAgendaLoading = true;
            this.tipoAgendaService
                .findAllComboSituacao(3, query)
                .then((body) => {
                    if (body.content) {
                        this.tipoAgendaSelect = body.content.map((m) => {
                            return {
                                id: m.idtipoagendaatividade,
                                label: m.situacao == 0 ? 'Inativo | ' + m.descricao : m.descricao,
                                situacao: m.situacao,
                                icone: m.icone == undefined ? 'fas fa-calendar' : m.icone,
                                cor: m.cor == undefined ? 'silver' : m.cor,
                            };
                        });
                    }
                })
                .catch((e) => {
                    console.error('Erro ao carregar tipo agenda.');
                })
                .finally((_) => {
                    this.tipoAgendaLoading = false;
                });
        },
        carregarCliente(query) {
            query = this.isNull(query) ? '.*' : this.removeToSearch(query);

            this.clienteLoading = true;
            this.clienteService
                .findAllComboSituacao(4, query)
                .then((body) => {
                    if (body.content) {
                        this.clienteSelect = body.content.map((m) => {
                            return {
                                id: m.idcliente,
                                label:
                                    m.replicapda == 2
                                        ? 'Inativo | ' + m.nome + ' - ' + m.rsocial
                                        : m.nome + ' - ' + m.rsocial,
                                replicapda: m.replicapda,
                            };
                        });
                    }
                })
                .catch((e) => {
                    console.error('Erro ao carregar cliente.');
                })
                .finally((_) => {
                    this.clienteLoading = false;
                });
        },
        // Propriedade
        loadPropriedade(query, clean = false) {
            if (clean) {
                this.propriedadeSelect = [];
                this.propriedadeSelected = null;
            }
            query = this.isNull(query) ? '.*' : this.removeToSearch(query);

            this.propriedadeLoading = true;
            let idsClientes = {};
            idsClientes = this.clienteSelected.map((e) => e.id);
            this.propriedadeService
                .listAllByMultipleIdsClientes(idsClientes, 300, 0, 2, query)
                .then((body) => {
                    return body.content.map((m) => {
                        return {
                            uuid: m.uuid,
                            nome: m.situacao != 1 ? 'Inativo | ' + m.nome : m.nome,
                            situacao: m.situacao,
                            origempda: m.origempda,
                        };
                    });
                })
                .then((value) => {
                    this.propriedadeSelect = value;
                })
                .catch(() => {
                    this.propriedadeSelect = [];
                    console.error('Erro ao carregar propriedade.');
                })
                .finally((_) => {
                    this.propriedadeLoading = false;
                });
        },
        carregarUsuario(query) {
            query = this.isNull(query) ? '.*' : this.removeToSearch(query);

            this.usuarioLoading = true;
            this.gerenciarUsuariosService
                .findAllComboSituacao(2, query)
                .then((body) => {
                    return body.content.map((m) => {
                        return {
                            id: m.idusuario,
                            idusuario: m.idusuario,
                            nome: m.situacao != 'A' ? 'Inativo | ' + m.nome : m.nome,
                            situacao: m.situacao,
                        };
                    });
                })
                .then((content) => {
                    this.usuarioSelect = content;
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa. Termo: [${query}]`);
                })
                .finally((_) => {
                    this.usuarioLoading = false;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;
    .page {
        position: relative;
        padding-left: 0;

        // Barra de filtro
        .filters-bar {
            display: flex;
            .filters-bar-form {
                flex-grow: 1;
            }
            .filters-bar-actions {
                display: flex;
                padding-bottom: 2px;
                align-items: stretch;
            }

            @media screen and (min-width: 851px) {
                .filters-bar-actions {
                    align-self: flex-end;
                    margin-left: 10px;
                    margin-bottom: 12px;
                }
            }
            @media screen and (max-width: 850px) {
                flex-direction: column;
                .filters-bar-actions {
                    align-self: center;
                    margin-top: 10px;
                }
            }
        }
    }
}
</style>
